import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';

import { MultiStepFormStore } from '../../../infrastructure/types/multi-step-form.types';

@Component({
  standalone: true,
  selector: 'remote-update-domain-left-menu',
  imports: [MatRadioModule],
  templateUrl: './left-menu.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './left-menu.css'
})
export class LeftMenu {
  @Input() items: { id: string; label: string }[] = [];
  @Input() currentSection = '';
  @Input() store?: MultiStepFormStore;
  @Output() selectSection = new EventEmitter<string>();

  isStepValid(stepId: string): boolean {
    return this.store?.isStepValid()?.(stepId) ?? false;
  }

  isStepDone(stepId: string): boolean {
    return this.store?.isStepDone()?.(stepId) ?? false;
  }

  canNavigateToStep(stepId: string): boolean {
    return this.store?.canNavigateToStep()?.(stepId) ?? false;
  }

  navigate(section: string) {
    if (!this.canNavigateToStep(section)) return;
    this.selectSection.emit(section);
  }
}
